import React, { useEffect, useState } from 'react';
import "./styles.css";
import {TextField, Button} from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import Logo from '../../assets/imgs/prospect_brasil.png'
import LogoBora from '../../assets/imgs/bora.png'
import api from '../../services/api';
import { salvarAcesso, mensagemErro } from '../../services/acesso';
import { toast  } from 'react-toastify';

const Login = () => {
    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")
    const [redirect,setRedirect] = useState(false)
    const [loading, setLoading] = useState(false);
    const [emailAtivo, setEmailAtivo] = useState(false);
    const [mostrarEsqueci, setMostrarEsqueci] = useState(false);
    const [emailRecuperacao, setEmailRecuperacao] = useState("");
    const [enviandoLink, setEnviandoLink] = useState(false);

    useEffect(() => {
        api.get("config-publica").then((result) => {
            setEmailAtivo(Boolean(result.data?.email_ativo));
        }).catch(() => {
            setEmailAtivo(false);
        });
    }, []);

    const handleLogin = async (event) => {
        if (event) event.preventDefault();

        if(!email) {
            toast.error("Informe seu e-mail");
            return
        }

        if(!password) {
            toast.error("Senha obrigatória");
            return
        }

        setLoading(true);

        await api.post("login", {
            email,
            password
        }).then(function(response){
            const login = response.data
            setLoading(false);
            localStorage.setItem("access_token", login.access_token);
            salvarAcesso(login.user);
            setRedirect(true)
            toast.success("Login realizado");
        })
        .catch(function (error) {
            localStorage.setItem("access_token","");
            setLoading(false);
            toast.error(mensagemErro(error, "Não autorizado"));
        })
    };

    const enviarLink = async () => {
        if (!emailRecuperacao) {
            toast.error("Informe o e-mail");
            return;
        }
        setEnviandoLink(true);
        try {
            const result = await api.post("esqueci-senha", { email: emailRecuperacao });
            toast.success(result.data?.message || "Se o e-mail estiver cadastrado, enviaremos um link para redefinir a senha.");
        } catch (error) {
            toast.error(mensagemErro(error, "Não foi possível enviar o link"));
        } finally {
            setEnviandoLink(false);
        }
    };

    if(redirect) {
        var host = window.location.protocol + "//" + window.location.host;
        window.location.href = `${host}/home`;
    }

    return (
    <div className="bodylogin">
        <form className="form_login" onSubmit={handleLogin}>
            <div className="logo-form-login" >
                <img src={Logo} width={200} alt="Prospect Brasil" />
            </div>

            <Grid item style={{paddingTop: "30px"}}>
                <TextField required id="standard-required" label="E-mail" onChange={(event) => setEmail(event.target.value)} value={email} fullWidth />
            </Grid>
            <Grid item style={{paddingTop: "30px"}}>
                <TextField required id="standard-required" type="password" label="Senha" onChange={(event) => setPassword(event.target.value)} value={password} fullWidth />
            </Grid>
            <Grid item style={{paddingTop: "30px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <Button variant="contained" color="primary" disabled={loading} type="submit">
                    ENTRAR
                </Button>
            </Grid>
            <Grid item style={{marginBottom:"10px",paddingTop: "20px",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <Button type="button" onClick={() => setMostrarEsqueci((valor) => !valor)}>
                    Esqueci a senha
                </Button>
            </Grid>
            {mostrarEsqueci && (
                emailAtivo ? (
                    <>
                        <Grid item>
                            <TextField label="E-mail para o link" value={emailRecuperacao} onChange={(event) => setEmailRecuperacao(event.target.value)} fullWidth />
                        </Grid>
                        <Grid item style={{paddingTop: "16px", display:"flex", justifyContent:"center"}}>
                            <Button variant="contained" color="primary" type="button" disabled={enviandoLink} onClick={enviarLink}>
                                Enviar link
                            </Button>
                        </Grid>
                    </>
                ) : (
                    <p style={{textAlign:"center"}}>Peça ao administrador do CRM um link de redefinição de senha</p>
                )
            )}
        </form>
        <div className="logo-bora" >
            <img src={LogoBora} width={200} alt="" />
        </div>
    </div>
  )
}

export default Login;
